import { Send } from 'lucide-react';
import {
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
} from 'react';
import { useChatStore } from '../../store/chatStore'; // adjust path if needed

const InputBar = forwardRef(function InputBar(
  { onSend },
  ref
) {
  const [text, setText] = useState('');
  const textareaRef = useRef(null);
  const { activeRole, isThinking } = useChatStore();

  useImperativeHandle(ref, () => ({
    focus: () => {
      if (textareaRef.current) {
        textareaRef.current.focus();
      }
    },
  }));

  const handleSend = () => {
    if (!text.trim() || isThinking) return;

    onSend(text.trim());
    setText('');

    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
    }
  };

  const handleKey = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const handleInput = () => {
    const el = textareaRef.current;
    if (el) {
      el.style.height = 'auto';
      el.style.height =
        Math.min(el.scrollHeight, 120) + 'px';
    }
  };

  const rolePill =
    activeRole === 'pre_sales'
      ? {
        bg: 'linear-gradient(264.28deg, #6666CC -38.2%, #CC0066 103.12%)',
        color: '#fff',
        border: 'linear-gradient(264.28deg, #6666CC -38.2%, #CC0066 103.12%)',
        label: 'Pre-Sales',
      }
      : {
        bg: 'linear-gradient(264.28deg, #6666CC -38.2%, #CC0066 103.12%)',
        color: '#fff',
        border: 'linear-gradient(264.28deg, #6666CC -38.2%, #CC0066 103.12%)',
        label: 'Marketing',
      };

  return (
    <div
      className="px-4 md:px-5 py-3"
      style={{
        background: '#0d1b2e',
        borderTop:
          '1px solid rgba(255,255,255,0.08)',
      }}
    >
      <div
        className="flex items-center gap-2 px-3 py-2 rounded-xl transition-colors"
        style={{
          background: 'rgba(255,255,255,0.07)',
          border:
            '1.5px solid rgba(255,255,255,0.20)',
        }}
        onFocus={(e) =>
        (e.currentTarget.style.borderColor =
          '#00fac2')
        }
        onBlur={(e) =>
        (e.currentTarget.style.borderColor =
          'rgba(255,255,255,0.20)')
        }
      >
        <span
          className="shrink-0 text-[11px] px-2 py-0.5 rounded-xl"
          style={{
            background: rolePill.bg,
            color: rolePill.color,
            border: `1px solid ${rolePill.border}`,
          }}
        >
          {rolePill.label}
        </span>

        <textarea
          ref={textareaRef}
          value={text}
          onChange={(e) =>
            setText(e.target.value)
          }
          onKeyDown={handleKey}
          onInput={handleInput}
          placeholder="Type your question..."
          rows={1}
          className="flex-1 bg-transparent text-white text-sm resize-none outline-none"
          style={{ color: '#FFFFFF', maxHeight: 120 }}
        />

        <button
          onClick={handleSend}
          disabled={!text.trim() || isThinking}
          className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0 transition-colors"
          style={{
            background:
              text.trim() && !isThinking
                ? '#00fac2'
                : 'rgba(255,255,255,0.10)',
          }}
        >
          <Send
            size={16}
            color={
              text.trim() && !isThinking
                ? '#0a1628'
                : 'rgba(255,255,255,0.30)'
            }
          />
        </button>
      </div>
    </div>
  );
});

export default InputBar;
